import { render, staticRenderFns } from "./PostCopy.vue?vue&type=template&id=3a7fecc9&"
import script from "./PostCopy.vue?vue&type=script&lang=js&"
export * from "./PostCopy.vue?vue&type=script&lang=js&"
import style0 from "./PostCopy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports